import Analytics from '../utils/Analytics';
import Environment from '../utils/Environment';
import {PAYWALL_EVENTS, PaymentType, PaywallSlug} from './paywallEvents';

/** Old per-type event names, dual-fired during the dashboard-migration window. */
const LEGACY_SHOWN_EVENTS: Record<PaymentType, string> = {
  apple: 'Apple Pay Shown',
  google: 'Google Pay Shown',
  card: 'Credit Card Shown',
};

/**
 * Emit the standard `[Web Payments] Paywall Payment Method Shown` event (with `paymentType`
 * and, when known, `paywall`) plus the legacy per-type name so existing dashboards keep
 * working. The specific method is a `paymentType` PROPERTY, not a distinct event name, so
 * the old `Apple Pay Shown` / `Google Pay Shown` / `Credit Card Shown` trio collapses into
 * one attributable event. Remove the legacy emit once dashboards are migrated.
 */
export function trackPaymentMethodShown(
  paymentType: PaymentType,
  props: {code?: string; paywall?: PaywallSlug; timing?: Record<string, number | boolean | string>} = {},
) {
  const {timing, ...rest} = props;
  const payload = {env: Environment.getVar('REACT_APP_ENV') ?? 'test', paymentType, ...rest, ...timing};
  Analytics.track(PAYWALL_EVENTS.paymentMethodShown, payload);
  Analytics.track(LEGACY_SHOWN_EVENTS[paymentType], payload);
}
